import { StyleSheet } from 'react-native';
import {
  defaultWidth,
  fontSizeMedium,
  green,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    textAlign: 'center',
  },
  connectButton: {
    backgroundColor: green,
  },
  header: {
    width: defaultWidth,
  },
  moreAccountError: {
    marginTop: 20,
  },
  platformText: {
    marginBottom: 20,
    fontSize: fontSizeMedium,
    width: defaultWidth,
  },
});
